import React from "react";
import Lottie from "lottie-react";
import techAnimation from "../assests/TechAnimation.json";
import "./sections/SaasSections.css";
import "./Product.css";
import "./LegalPages.css";

export default function LegalPageLayout({ title, updated, children }) {
  return (
    <div className="legal-page">
      <div className="productHero">
        <div className="topCurve"></div>
        <div className="productCardFull">
          <div className="logo_curve1"></div>
          <div className="logo_curve2"></div>
          <div className="menu-icon-curve1"></div>
          <div className="menu-icon-curve2"></div>
          <div className="logo_curve1_Mo"></div>
          <div className="logo_curve2_Mo"></div>
          <div className="menu-icon-curve1_MV"></div>
          <div className="menu-icon-curve2_MV"></div>
          <div className="productContent">
            <h1 className="productTitle">{title}</h1>
            <p className="legal-hero-date">Last updated: {updated}</p>
          </div>
          <div className="productAnimation">
            <Lottie animationData={techAnimation} loop={true} speed={0.1} />
          </div>
        </div>
      </div>

      <section className="saas-section products-page-section">
        <h2 className="saas-section__title">{title.toUpperCase()}</h2>
        <div className="saas-section__header">
          <p className="saas-section__intro">
            Quinterra Software Solutions Pvt. Ltd. is committed to transparency in how we operate
            our AI SaaS products and services. Please read the details below carefully.
          </p>
        </div>
        <div className="saas-section__body legal-body__content">{children}</div>
      </section>
    </div>
  );
}
